import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getResetPasswordStatus } from 'store/apiStatus';
import { resetPasswordRequest } from 'store/auth';

import { ResetPassword, ResetPasswordSuccess } from 'components';

export const ResetPasswordContainer = ({
  location,
  status,
  onResetPassword
}) => {
  return status.success ? (
    <ResetPasswordSuccess />
  ) : (
    <ResetPassword
      location={location}
      status={status}
      onSubmit={onResetPassword}
    />
  );
};

ResetPasswordContainer.propTypes = {
  location: PropTypes.object.isRequired,
  status: PropTypes.object.isRequired,
  onResetPassword: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  status: getResetPasswordStatus(state)
});

const mapDispatchToProps = {
  onResetPassword: resetPasswordRequest
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ResetPasswordContainer
);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordContainer/ResetPasswordContainer.js